import React from 'react'
import DropDown from './DropDown'

function CardNotifications() {
    return (
            <DropDown nameDropDown="cita">
                <p>hello</p>
                <p>sayonara</p>
                <p>Tio</p>
            </DropDown>
    )
}

export default CardNotifications
